/**
 * Homepage entry — the pixel-matched build of Figma "Main Page".
 *
 * Kept separate from main.js so the legacy header/footer partials in
 * main.scss cannot collide with the homepage's measured styles. Enqueued
 * instead of main.js on the front page (inc/assets.php).
 */

// Self-hosted fonts (Fontsource). Not Google Fonts: loading from
// fonts.googleapis.com transmits readers' IP addresses to Google, which an
// EU court has held to be a GDPR violation — a real risk for Polish portals.
// Latin + latin-ext only: Polish diacritics live in latin-ext, and nothing
// else is needed, so the other subsets never enter the build.
import '../css/fonts.css'; // latin + latin-ext faces with unicode-range (see the file)

// Tokens first — home.scss consumes them; the brand file enqueued after
// this bundle overrides the brand subset.
import '../css/tokens.css';
import '../scss/home.scss';

import { initAds } from './ads.js';
import { initMobileMenu } from './menu.js';
import { initScrollers } from './scroll.js';
import { initToggles } from './toggles.js';
import { initContactForm } from './contact.js';
import { initConsent } from './consent.js';
import { initSticky } from './sticky.js';
import { initShare } from './share.js';
import { initLightbox } from './lightbox.js';
import { initTicker } from './ticker.js';
import { initPartners } from './partners.js';
import { initNavSearch } from './nav-search.js';
import { initMobileSearch } from './m-search.js';
import { initMobileHeader } from './m-header.js';
import { initVideoEmbeds } from './video.js';

// Each module on its own: one that throws (an API an older browser lacks)
// must not stop the menu, consent, sharing… that come after it. Ads first:
// a slot it collapses must be gone before the carousels measure their tracks.
const init = () => {
  [
    initAds, initMobileMenu, initScrollers, initToggles, initContactForm, initConsent, initSticky, initShare,
    initLightbox, initTicker, initPartners, initNavSearch, initMobileSearch, initMobileHeader, initVideoEmbeds,
  ].forEach((start) => {
    try {
      start();
    } catch (error) {
      console.error(error); // eslint-disable-line no-console
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
